const BLOCK_HIGHLIGHT_TAGS = new Set(["P", "LI"])

export function normalizeHighlightedBlockWrappers(container) {
    const wrappers = [...container.querySelectorAll("span.schedule-text-difference")]

    for (const wrapper of wrappers) {
        const blockChild = resolveSingleBlockChild(wrapper)
        if (!blockChild) continue

        transferWrapperAttributes(wrapper, blockChild)
        wrapper.replaceWith(blockChild)
    }
}

function resolveSingleBlockChild(wrapper) {
    const meaningfulChildren = [...wrapper.childNodes].filter(isMeaningfulNode)
    if (meaningfulChildren.length !== 1) return null

    const [child] = meaningfulChildren
    if (!(child instanceof Element)) return null
    if (!BLOCK_HIGHLIGHT_TAGS.has(child.tagName)) return null

    return child.cloneNode(true)
}

function isMeaningfulNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent.trim().length > 0
    }

    return node.nodeType === Node.ELEMENT_NODE
}

function transferWrapperAttributes(wrapper, child) {
    const wrapperClassName = `${wrapper.getAttribute("class") || ""}`.trim()
    const childClassName = `${child.getAttribute("class") || ""}`.trim()
    const mergedClassName = [childClassName, wrapperClassName].filter(Boolean).join(" ")
    if (mergedClassName) {
        child.setAttribute("class", mergedClassName)
    }

    copyAttribute(wrapper, child, "style")
    copyAttribute(wrapper, child, "onmouseover")
    copyAttribute(wrapper, child, "onmouseout")
}

function copyAttribute(source, target, name) {
    const value = source.getAttribute(name)
    if (!value) return
    target.setAttribute(name, value)
}
